/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { getAccessibleComponentToRender } from "./AccessibilityComponentHelper";

export const AccessibleParagraphNode = ({ style, paragraph, zoomLevel, pageIndex }) => {
  if (!paragraph.children) return null;
  return (
    <p className="acc_text" tabIndex="-1" style={style}>
      {paragraph.children.map((child, childIndex) =>
        getAccessibleComponentToRender(child, zoomLevel, `parachild${childIndex}`, pageIndex, paragraph)
      )}
    </p>
  );
};
